/**
 * How long the object URL outlives the click. Revoking it straight after `click()` can cancel
 * the download in browsers that start it asynchronously (Firefox, Safari); file-saver, which this
 * replaces, waited the same 40 s. Never revoking it keeps the blob alive until the page unloads.
 */
export const SAVE_BLOB_REVOKE_DELAY_MS = 40_000;

/** Hands the bytes to the browser as a download named `fileName`. */
export function saveBlob(blob: Blob, fileName: string): void {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.rel = 'noopener';
    link.click();
    setTimeout(() => URL.revokeObjectURL(url), SAVE_BLOB_REVOKE_DELAY_MS);
}
